import MedicineComponent from "@components/Medicine/Medicine";

export default function Medicine() {
  return <MedicineComponent />;
}
